import type { ClientInput, Split } from '../types';
import type { Tracer } from '../tracer';

/**
 * Split rule — pick training split based on frequency.
 *
 *   2-3 days → full body
 *   4 days   → upper / lower
 *   5-6 days → push / pull / legs
 */
export function splitRule(client: ClientInput, trace: Tracer): Split {
  const days = client.schedule.days_per_week;
  const split = pickSplit(days);

  trace.emit('split', split, `Days/week: ${days} → ${split}`, { days_per_week: days });

  return split;
}

function pickSplit(days: number): Split {
  if (days <= 3) return 'full_body';
  if (days === 4) return 'upper_lower';
  return 'push_pull_legs';
}

export const _internal = { pickSplit };
